import { render, staticRenderFns } from "./CollectionCreator.vue?vue&type=template&id=e5ea855a"
import script from "./CollectionCreator.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionCreator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CollectionCreator.vue?vue&type=style&index=0&id=e5ea855a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports